import { defineStore } from 'pinia';

/**
 * Desfechos fechados por automação que ainda esperam o que só uma pessoa sabe:
 * o valor de um ganho, o motivo de uma perda.
 *
 * O pedido chega pelo canal do próprio usuário (`pipeline_card.completion_pending`)
 * e é consumido pelo `DealCompletionPrompt`, montado no Dashboard — por isso
 * funciona na tela de conversa, que é onde a etiqueta costuma ser colocada, e
 * não só no Pipeline.
 *
 * A fila existe porque uma etiqueta pode fechar mais de um card de uma vez
 * (conversa vinculada a vários) e porque duas etiquetas podem chegar enquanto o
 * modal da primeira está aberto: perder o segundo pedido deixaria um negócio
 * fechado sem valor e sem ninguém sabendo — exatamente o que este ciclo corrige.
 */
export const useDealCompletionStore = defineStore('dealCompletion', {
  state: () => ({
    queue: [],
  }),

  getters: {
    current: state => state.queue[0] || null,
    hasPending: state => state.queue.length > 0,
  },

  actions: {
    enqueue(request) {
      if (!request?.cardId) return;
      // Um card só entra uma vez: o mesmo pedido pode chegar duas vezes quando
      // o usuário tem duas abas abertas no mesmo pubsub_token.
      if (this.queue.some(item => item.cardId === request.cardId)) return;

      this.queue.push(request);
    },

    // Resolvido (preenchido) ou dispensado: em ambos os casos sai da fila. A
    // pendência em si continua marcada no card no servidor, então dispensar não
    // apaga o pedido — só tira o modal da frente de quem está no meio de outra
    // coisa.
    resolve(cardId) {
      this.queue = this.queue.filter(item => item.cardId !== cardId);
    },

    clear() {
      this.queue = [];
    },
  },
});
